// Central testIds registry for Sushen Herbs
export const TID = {
    // Home
    customerHome: "customer-home",
    heroSearch: "hero-search",
    categoryChip: (name) => `category-chip-${name}`,
    productCard: (pid) => `product-card-${pid}`,
    doctorCard: (did) => `doctor-card-${did}`,

    // Header
    headerSigninBtn: "header-signin-btn",
    headerLogo: "header-logo",
    headerJoinDoctorLink: "header-join-doctor-link",
    headerCartLink: "header-cart-link",
    headerOrdersLink: "header-orders-link",
    headerLogout: "header-logout",
    headerAdminOverviewLink: "header-admin-overview",
    headerDoctorDashboardLink: "header-doctor-dashboard",
    headerNavWellness: "header-nav-wellness",
    headerNavShop: "header-nav-shop",

    // Home CTAs
    homeCtaBookLink: "home-cta-book-link",
    heroTakeQuiz: "hero-take-quiz",
    heroSeeProfile: "hero-see-profile",
    heroBrowseShop: "hero-browse-shop",

    // Wellness
    doshaQuiz: "dosha-quiz",
    doshaQuizProgress: "dosha-quiz-progress",
    doshaQuizQuestion: (qid) => `dosha-quiz-question-${qid}`,
    doshaQuizOption: (qid, dosha) => `dosha-quiz-option-${qid}-${dosha}`,
    doshaQuizBack: "dosha-quiz-back",
    doshaQuizNext: "dosha-quiz-next",
    doshaQuizSubmit: "dosha-quiz-submit",
    doshaProfile: "dosha-profile",
    doshaProfileName: "dosha-profile-name",
    doshaProfileRetake: "dosha-profile-retake",
    wellnessDoshaSnapshot: "wellness-dosha-snapshot",
    wellnessDailyTip: "wellness-daily-tip",
    wellnessRitual: "wellness-ritual",

    // AI Guide
    aiGuidePage: "ai-guide-page",
    guideProvider: (p) => `guide-provider-${p}`,
    guideInput: "guide-input",
    guideSend: "guide-send",
    guideNewChat: "guide-new-chat",
    guideHistoryBtn: "guide-history-btn",
    guideStarter: (slug) => `guide-starter-${slug}`,
    guideUserBubble: "guide-user-bubble",
    guideAssistantBubble: "guide-assistant-bubble",
    headerNavGuide: "header-nav-guide",
    homeCtaAiGuide: "home-cta-ai-guide",

    // Patient onboarding
    onboardingForm: "onboarding-form",
    onboardingPhoneCountry: "onboarding-phone-country",
    onboardingPhone: "onboarding-phone",
    onboardingDob: "onboarding-dob",
    onboardingGender: (g) => `onboarding-gender-${g}`,
    onboardingHeight: "onboarding-height",
    onboardingWeight: "onboarding-weight",
    onboardingBloodGroup: "onboarding-blood-group",
    onboardingCity: "onboarding-city",
    onboardingOccupation: "onboarding-occupation",
    onboardingIllnessChip: (slug) => `onboarding-illness-${slug}`,
    onboardingSubmit: "onboarding-submit",

    // Patient dashboard
    patientDashboard: "patient-dashboard",
    dashboardEditProfile: "dashboard-edit-profile",
    dashboardProfileCard: "dashboard-profile-card",
    dashboardPatientCode: "dashboard-patient-code",
    dashboardCopyCode: "dashboard-copy-code",
    dashboardDoshaCard: "dashboard-dosha-card",
    dashboardHealthCard: "dashboard-health-card",
    dashboardHealthCta: "dashboard-health-cta",
    dashboardRituals: "dashboard-rituals",
    dashboardRitualToggle: (k) => `dashboard-ritual-toggle-${k}`,
    dashboardConsultations: "dashboard-consultations",
    dashboardJournal: "dashboard-journal",
    dashboardLearn: "dashboard-learn",
    dashboardRecommendations: "dashboard-recommendations",

    // Health profile page
    healthProfilePage: "health-profile-page",
    healthProfileForm: "health-profile-form",
    healthProfileSubmit: "health-profile-submit",
    healthProfileField: (k) => `health-profile-${k}`,

    // Vitals page (patient)
    vitalsPage: "vitals-page",
    vitalsAddForm: "vitals-add-form",
    vitalsMetric: "vitals-metric",
    vitalsValue: "vitals-value",
    vitalsSecondary: "vitals-secondary",
    vitalsCustomName: "vitals-custom-name",
    vitalsUnit: "vitals-unit",
    vitalsDate: "vitals-date",
    vitalsNote: "vitals-note",
    vitalsSubmit: "vitals-submit",
    vitalsChart: (m) => `vitals-chart-${m}`,
    vitalsRow: (id) => `vitals-row-${id}`,
    vitalsDelete: (id) => `vitals-delete-${id}`,
    dashboardVitalsCard: "dashboard-vitals-card",
    dashboardVitalsCta: "dashboard-vitals-cta",

    // Test suggestions
    testsPage: "tests-page",
    testsRequestForm: "tests-request-form",
    testsRequestName: "tests-request-name",
    testsRequestNotes: "tests-request-notes",
    testsRequestSubmit: "tests-request-submit",
    testsPresetChip: (name) => `tests-preset-${name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    testsItem: (sid) => `tests-item-${sid}`,
    testsUpload: (sid) => `tests-upload-${sid}`,
    testsMarkDone: (sid) => `tests-mark-done-${sid}`,
    testsMarkDeclined: (sid) => `tests-mark-declined-${sid}`,
    testsDelete: (sid) => `tests-delete-${sid}`,
    testsReport: (rid) => `tests-report-${rid}`,
    dashboardTestsCard: "dashboard-tests-card",
    dashboardTestsCta: "dashboard-tests-cta",

    // Doctor patient view — new sections
    doctorPatientVitals: "doctor-patient-vitals",
    doctorPatientTests: "doctor-patient-tests",
    doctorSuggestTestForm: "doctor-suggest-test-form",
    doctorSuggestTestName: "doctor-suggest-test-name",
    doctorSuggestTestNotes: "doctor-suggest-test-notes",
    doctorSuggestTestSubmit: "doctor-suggest-test-submit",
    doctorAcceptRequest: (sid) => `doctor-accept-request-${sid}`,

    // Unified onboarding quiz (dosha + symptom triage)
    quizPage: "quiz-page",
    quizProgress: "quiz-progress",
    quizQuestion: (qid) => `quiz-question-${qid}`,
    quizOption: (qid, aid) => `quiz-option-${qid}-${aid}`,
    quizBack: "quiz-back",
    quizNext: "quiz-next",
    quizSubmit: "quiz-submit",
    quizRedFlag: "quiz-red-flag",
    quizRedFlagBook: "quiz-red-flag-book",
    quizTeaser: "quiz-teaser",
    quizSignupCta: "quiz-signup-cta",
    quizFullResult: "quiz-full-result",

    // Admin quiz
    adminQuizPage: "admin-quiz-page",
    adminQuizItem: (qid) => `admin-quiz-item-${qid}`,
    adminQuizToggleActive: (qid) => `admin-quiz-toggle-${qid}`,
    adminQuizEdit: (qid) => `admin-quiz-edit-${qid}`,
    adminQuizDelete: (qid) => `admin-quiz-delete-${qid}`,
    adminQuizAdd: "admin-quiz-add",
    adminQuizSubmissions: "admin-quiz-submissions",

    // Vaidya triage inbox
    triagePage: "triage-page",
    triageFilterStatus: (s) => `triage-filter-${s}`,
    triageItem: (sid) => `triage-item-${sid}`,
    triageClaim: (sid) => `triage-claim-${sid}`,
    triageUnclaim: (sid) => `triage-unclaim-${sid}`,
    triageResolve: (sid) => `triage-resolve-${sid}`,
    triageDismiss: (sid) => `triage-dismiss-${sid}`,
    triageReopen: (sid) => `triage-reopen-${sid}`,
    triageNoteInput: (sid) => `triage-note-input-${sid}`,
    triageNoteSubmit: (sid) => `triage-note-submit-${sid}`,
    headerTriageBadge: "header-triage-badge",
    journalForm: "journal-form",
    journalMood: "journal-mood",
    journalSleep: "journal-sleep",
    journalEnergy: "journal-energy",
    journalNote: "journal-note",
    journalSubmit: "journal-submit",
    learnLessonCard: (id) => `learn-lesson-${id}`,
    recommendedCard: (pid) => `recommended-card-${pid}`,
    patientRxList: (cid) => `patient-rx-list-${cid}`,
    headerNavDashboard: "header-nav-dashboard",

    // Account
    headerChangePasswordLink: "header-change-password-link",
    changePasswordForm: "change-password-form",
    changePasswordCurrent: "change-password-current",
    changePasswordNew: "change-password-new",
    changePasswordConfirm: "change-password-confirm",
    changePasswordSubmit: "change-password-submit",
    changePasswordError: "change-password-error",

    // Login modal
    loginModal: "login-modal",
    modalEmailInput: "modal-email-input",
    modalPasswordInput: "modal-password-input",
    modalLoginSubmit: "modal-login-submit",
    modalTabCustomer: "modal-tab-customer",
    modalTabNew: "modal-tab-new",
    modalGoogleSignin: "modal-google-signin",
    modalDemoAdmin: "modal-demo-admin",
    modalDemoCustomer: "modal-demo-customer",
    modalDemoDoctor: "modal-demo-doctor",
    modalDoctorSignup: "go-to-doctor-signup",
    modalClose: "modal-close",

    // Actions (auth-gated)
    addToCartBtn: "add-to-cart-btn",
    bookConsultationBtn: "book-consultation-btn",
    rateBtn: "rate-btn",
    placeOrderBtn: "place-order-btn",

    // Cart
    cartBadge: "cart-badge",
    cartQtyInc: (pid) => `cart-qty-inc-${pid}`,
    cartQtyDec: (pid) => `cart-qty-dec-${pid}`,
    cartAddressInput: "cart-address-input",
    cartPhoneInput: "cart-phone-input",

    // Chat
    chatInput: "chat-input",
    chatSend: "chat-send",
    chatAttach: "chat-attach",

    // Doctor auth
    docSignupLink: "doc-signup-link",
    doctorRegisterScreen: "doctor-register-screen",
    doctorPendingScreen: "doctor-pending-screen",

    // Admin
    adminOverview: "admin-overview",
    revenueChart: "revenue-chart",
    topProductsBlock: "top-products-block",
    topDoctorsBlock: "top-doctors-block",
    mixBlock: "mix-block",
    lowStockBlock: "low-stock-block",
    pendingDoctorsBlock: "pending-doctors-block",
    adminProducts: "admin-products",
    editProduct: (pid) => `edit-product-${pid}`,
    editProductName: "edit-product-name",
    editProductCompany: "edit-product-company",
    editProductCategory: "edit-product-category",
    editProductCategoryChip: (slug) => `edit-product-category-chip-${slug}`,
    editProductPreview: "edit-product-preview",
    editProductUploadBtn: "edit-product-upload-btn",
    editProductRemoveImage: "edit-product-remove-image",
    editProductUrlInput: "edit-product-url-input",
    rowImageSwapBtn: (pid) => `row-image-swap-${pid}`,
    saveProduct: "save-product",
    productDetailCompany: "product-detail-company",
    adminDoctors: "admin-doctors",
    approve: (did) => `approve-${did}`,
    reject: (did) => `reject-${did}`,
    verifiedBadge: (did) => `verified-badge-${did}`,
    adminOrders: "admin-orders",

    // Admin users (password reset)
    adminUsers: "admin-users",
    adminUsersSearch: "admin-users-search",
    adminUsersRoleChip: (r) => `admin-users-role-${r}`,
    adminUserRow: (uid) => `admin-user-row-${uid}`,
    adminUserResetPw: (uid) => `admin-user-reset-pw-${uid}`,
    adminUsersPwDialog: "admin-users-pw-dialog",
    adminUsersPwNew: "admin-users-pw-new",
    adminUsersPwConfirm: "admin-users-pw-confirm",
    adminUsersPwSubmit: "admin-users-pw-submit",
    adminUsersPwCancel: "admin-users-pw-cancel",

    // Visitors (day-wise analytics)
    visitorsBlock: "visitors-block",
    visitorsTotalUnique: "visitors-total-unique",
    visitorsTotalPageviews: "visitors-total-pageviews",
    visitorsRangeBtn: (n) => `visitors-range-${n}`,
    visitorBar: (date) => `visitor-bar-${date}`,

    // Doctor appointments panel
    doctorAppointments: "doctor-appointments",
    doctorAppointmentsTab: (t) => `doctor-appointments-tab-${t}`,
    doctorAppointmentsUpcomingCount: "doctor-appointments-upcoming-count",
    doctorAppointmentCard: (cid) => `doctor-appointment-card-${cid}`,
    doctorAppointmentOpenChat: (cid) => `doctor-appointment-open-chat-${cid}`,
    doctorAppointmentComplete: (cid) => `doctor-appointment-complete-${cid}`,
    doctorAppointmentCancel: (cid) => `doctor-appointment-cancel-${cid}`,
    doctorAppointmentPatientAvatar: (cid) => `doctor-appointment-patient-avatar-${cid}`,
    doctorAppointmentPatientName: (cid) => `doctor-appointment-patient-name-${cid}`,
    doctorAppointmentAddRx: (cid) => `doctor-appointment-add-rx-${cid}`,
    doctorAppointmentPrescriptions: (cid) => `doctor-appointment-prescriptions-${cid}`,
    doctorAppointmentRxRemove: (rxId) => `doctor-appointment-rx-remove-${rxId}`,
    doctorRxModal: "doctor-rx-modal",
    doctorRxMedicine: "doctor-rx-medicine",
    doctorRxDosage: "doctor-rx-dosage",
    doctorRxDays: "doctor-rx-days",
    doctorRxFrequency: "doctor-rx-frequency",
    doctorRxNotes: "doctor-rx-notes",
    doctorRxSubmit: "doctor-rx-submit",
    doctorNavAppointments: "doctor-nav-appointments",
    doctorPatientView: "doctor-patient-view",
    doctorPatientCode: "doctor-patient-code",
    doctorDashboardRoot: "doctor-dashboard-root",
    doctorMyProfile: "doctor-my-profile",
    doctorFollowUps: "doctor-follow-ups",
    doctorFollowUpAdd: "doctor-follow-up-add",
    doctorFollowUpForm: "doctor-follow-up-form",
    doctorFollowUpPatient: "doctor-follow-up-patient",
    doctorFollowUpDate: "doctor-follow-up-date",
    doctorFollowUpNotes: "doctor-follow-up-notes",
    doctorFollowUpSubmit: "doctor-follow-up-submit",
    doctorFollowUpItem: (fid) => `doctor-follow-up-item-${fid}`,
    doctorFollowUpDone: (fid) => `doctor-follow-up-done-${fid}`,
    doctorFollowUpNudge: (fid) => `doctor-follow-up-nudge-${fid}`,
    doctorRxTemplateName: "doctor-rx-template-name",
    doctorRxTemplateSave: "doctor-rx-template-save",
    doctorRxTemplateApply: (tid) => `doctor-rx-template-apply-${tid}`,
    doctorCalendar: "doctor-calendar",
    doctorCalendarPrev: "doctor-calendar-prev",
    doctorCalendarNext: "doctor-calendar-next",
    doctorCalendarDay: (date) => `doctor-calendar-day-${date}`,
    headerFollowUpBadge: "header-follow-up-badge",

    // Doctor onboarding form
    docregName: "docreg-name",
    docregEmail: "docreg-email",
    docregPassword: "docreg-password",
    docregPhone: "docreg-phone",
    docregTitle: "docreg-title",
    docregSpecialty: "docreg-specialty",
    docregDegreeName: "docreg-degree-name",
    docregExperience: "docreg-experience",
    docregQualifications: "docreg-qualifications",
    docregDegreeDoc: "docreg-degree-doc",
    docregLicense: "docreg-license",
    docregLicenseDoc: "docreg-license-doc",
    docregClinicName: "docreg-clinic-name",
    docregClinicAddress: "docreg-clinic-address",
    docregLocationChip: (slug) => `docreg-location-${slug}`,
    docregError: "docreg-error",
    docregSubmit: "docreg-submit",
};

export default TID;
